/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_IntroInputs */

const en_pc_tut_open_intro = /** @type {(inputs: Pc_Tut_Open_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft opens most PDFs instantly and renders complex scripts and transparency faithfully.`)
};

const zh_pc_tut_open_intro = /** @type {(inputs: Pc_Tut_Open_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 能瞬间打开绝大多数 PDF，并忠实渲染复杂文字与透明效果。`)
};

/**
* | output |
* | --- |
* | "PdfCraft opens most PDFs instantly and renders complex scripts and transparency faithfully." |
*
* @param {Pc_Tut_Open_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_intro = /** @type {((inputs?: Pc_Tut_Open_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_intro(inputs)
	return zh_pc_tut_open_intro(inputs)
});
export { pc_tut_open_intro as "pc.tut.open.intro" }